import { gql } from 'graphql-request'

export const QueryBlockIntegrationListing = gql`
  fragment FragmentBlockIntegrationListing on BlockIntegrationListingModelRecord {
          __typename
          id
          title
          preface
          description {
            value
          }
          integrations {
            __typename
            id
            logo {
              title
              url
            }
            slug
            title
            label
            categories {
              title
              slug
              typeField
              icon
            }
            markets {
              title
              countryIsoCode
            }
          }
          primaryAction {
            ...FragmentNavigationItem
          }
          contentList {
            ...FragmentSimpleBlock
          }
        }
`
export const BlockIntegrationListing = {
  __typename: 'BlockIntegrationListing',
  fragmentName: 'FragmentBlockIntegrationListing',
  fragmentQuery: QueryBlockIntegrationListing,
  fragments: ['FragmentSimpleBlock', 'FragmentNavigationItem', 'FragmentFormattedTextBlock']
}
